<template>
  <div class="d-grid" style="grid-template-columns: auto 1fr">
    <div class="badge" :class="{ [status_badge_color]: true, 'rounded-end-0': is_copying }">{{
      status_label[$i18n.locale] }}</div>
    <progress v-if="is_copying" class="progress rounded-start-0 h-100" :value="progress_current"
      :max="progress_total">{{ percentage }}</progress>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType, ContestDuplicatorInitialData } from "@/types";
import { ElectionCopierChannelSubscription } from "@/channels/ElectionCopierChannel";

interface Data {
  initial_data: ContestDuplicatorInitialData
}

export default defineComponent({
  name: "ElectionCopierProgress",
  props: {
    election_copier_id: {
      type: Number,
      required: true,
    },
    initial_data: {
      type: Object as PropType<ContestDuplicatorInitialData>,
      default: () => ({}),
    },
  },
  data: ({ initial_data: { status, status_label, progress_current, progress_total } }: Data) => ({
    status,
    status_label,
    progress_current,
    progress_total,
    subscription: null as ElectionCopierChannelSubscription | null,
  }),
  computed: {
    status_badge_color() {
      switch (this.status) {
        case "failed": return 'text-bg-danger';
        case "finished": return 'text-bg-success';
        default: return 'text-bg-dark';
      }
    },
    percentage() {
      return `${100 * this.progress_current / this.progress_total}%`;
    },
    is_copying() {
      return this.status === "copying";
    },
  },
  methods: {
    handleReceived({ progress_current, progress_total, status, status_label }) {
      console.debug("received")
      this.progress_current = progress_current;
      this.progress_total = progress_total;
      this.status = status;
      this.status_label = status_label;
    }
  },
  created() {
    this.subscription = new ElectionCopierChannelSubscription(
      this.election_copier_id,
      {
        received: this.handleReceived,
      });
  },
  beforeUnmount() {
    this.subscription?.unsubscribe();
  },
});
</script>
